export const QUERY_KEYS = {
  TEST_CONTENT_GET: "TEST_CONTENT_GET",
};
